<script setup>
// BonBoZ: kho ảnh marketing — chọn một lần, gửi cho mọi khách.
//
// MỘT KHO CHUNG cho mọi trang. Từng tách theo trang (11/09–17/09/2026) để giữ
// quyền inbox, nhưng người dùng thật muốn một bộ ảnh dùng cho mọi trang thay vì
// chép qua chép lại — xem migration `gop_kho_anh_chung`.
//
// VÌ SAO KHÔNG DÙNG NÚT ĐÍNH KÈM SẴN CÓ: nút đó tải tệp từ máy nhân viên lên
// từng lần. Ảnh tư vấn dùng đi dùng lại hàng trăm lượt — mỗi lần lại đi tìm
// trong máy vừa chậm vừa dễ gửi nhầm bản cũ. Fork này đã tắt nút đó từ trước
// (`BAT_DINH_KEM` trong ReplyBottomPanel.vue).
//
// CHỌN KHÔNG PHẢI LÀ GỬI. Bấm ảnh chỉ đánh dấu; bấm "Chèn" mới đưa về khung soạn
// tin như tệp đính kèm bình thường; nhân viên gõ lời nhắn rồi bấm nút gửi quen
// thuộc. Gửi ngay lúc bấm là sai: một cú bấm nhầm thành một tin thật tới khách,
// mà Meta không cho thu hồi.
//
// CHỌN ĐƯỢC NHIỀU TẤM. Facebook/Instagram gửi cả cụm trong MỘT tin — một bong
// bóng, lưới ảnh, đúng như Pancake (xem `KhoAnhPancake#gui_nhieu!`). Zalo không
// có `attachment_id` nên backend tự rơi về gửi từng tấm.
//
// LƯỚI TẢI DẦN. Trang Bonboz Clinic có 344 tấm và thẻ ảnh trỏ thẳng vào ảnh gốc
// (~262 KB một tấm) — dựng hết một lượt là tải ~90 MB. Server trả 60 tấm mỗi
// trang, cuộn tới đáy mới xin tiếp.
//
// TÌM KIẾM CHẠY Ở SERVER chứ không lọc trong mảng đang có: lọc phía trình duyệt
// thì chỉ tìm được trong 60 tấm đã tải, gõ đúng tên ảnh ở trang sau vẫn ra rỗng.
import { ref, computed, watch, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useAdmin } from 'dashboard/composables/useAdmin';
import KhoAnhAPI from 'dashboard/api/bonboz/khoAnh';
import { chenAnhVaoKhay } from 'dashboard/helper/bonboz/khoAnh';
import Modal from 'dashboard/components/Modal.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  // Chinh la ham ReplyBox dung cho nut dinh kem san co — dua anh vao day thi no
  // di tiep y het mot tep nguoi dung tu chon.
  onFileUpload: { type: Function, default: null },
  // BonBoZ: che do CHON CHO MAU TRA LOI. Mau chi luu ID anh chu khong luu ban
  // sao, nen o che do nay bang khong tai anh ve ma tra anh da chon ra ngoai.
  traVeId: { type: Boolean, default: false },
  // Goi sau khi da chen xong, de ReplyBox dua con tro ve khung soan — dong modal
  // xong tieu diem roi ve body, khong go hay Enter ngay duoc.
  sauKhiChen: { type: Function, default: null },
  // Gỡ một ảnh kho khỏi khay khung soạn (theo id ảnh).
  boKhoiKhay: { type: Function, default: null },
});
const emit = defineEmits(['chon']);
const hien = defineModel('show', { type: Boolean, default: false });

const { t } = useI18n();
const { isAdmin } = useAdmin();

const dsAnh = ref([]);
const dsThuMuc = ref([]);
const soChuaXep = ref(0);
const soYeuThich = ref(0);
const tatCaId = ref([]);
// '' = tất cả, 'chua_xep', 'yeu_thich', hoặc id thư mục.
const thuMucChon = ref('');
const tuKhoa = ref('');
const timThuMuc = ref('');

// Khớp AnhMktsController::SAP_XEP. Hàng rào cho localStorage cũ/hỏng.
const SAP_XEP_HOP_LE = ['moi_nhat', 'cu_nhat', 'ten_az', 'ten_za'];
const KHOA_SAP_XEP = 'bonboz_kho_anh_sap_xep';
// Nhớ lựa chọn giữa các lần mở. localStorage ném lỗi ở chế độ riêng tư nên bọc
// try — hỏng thì về mặc định chứ không làm vỡ bảng.
const docSapXep = () => {
  try {
    const luu = window.localStorage.getItem(KHOA_SAP_XEP);
    return SAP_XEP_HOP_LE.includes(luu) ? luu : 'moi_nhat';
  } catch {
    return 'moi_nhat';
  }
};
const sapXep = ref(docSapXep());
const trang = ref(1);
const conNua = ref(false);
const dangTai = ref(false);
const dangTaiThem = ref(false);
const dangChen = ref(false);
const dangKeo = ref(false);
const dangLam = ref(false);
// Giữ theo THỨ TỰ bấm, không phải thứ tự trong lưới: người trực bấm 1-2-3 thì
// khách phải thấy 1-2-3.
const daChon = ref([]);
// Ảnh đã nằm trong khay khung soạn trong lần mở bảng này (tự vào lúc tải lên,
// hoặc đã chèn). "Chèn" bỏ qua chúng để không nhân đôi; bỏ chọn thì gỡ khỏi khay.
const daVaoKhay = ref([]);
const hopXoa = ref(null);
const anhSapXoa = ref(null);
const hopChuyen = ref(null);
const thuMucDich = ref('');
const kieuChuyen = ref('them');
const hopSuaTen = ref(null);
const anhSuaTen = ref(null);
const tenMoi = ref('');
const hopThuMuc = ref(null);
const thuMucSua = ref(null);
const tenThuMuc = ref('');
const hopXoaThuMuc = ref(null);
const thuMucSapXoa = ref(null);

const thuMucHienThi = computed(() => {
  const k = timThuMuc.value.trim().toLowerCase();
  if (!k) return dsThuMuc.value;
  return dsThuMuc.value.filter(tm => tm.ten.toLowerCase().includes(k));
});

const thamSo = () => ({
  tuKhoa: tuKhoa.value.trim(),
  yeuThich: thuMucChon.value === 'yeu_thich',
  thuMuc: thuMucChon.value === 'yeu_thich' ? '' : thuMucChon.value,
  sapXep: sapXep.value,
});

const nap = async () => {
  dangTai.value = true;
  trang.value = 1;
  try {
    const { data } = await KhoAnhAPI.danhSach({ ...thamSo(), trang: 1 });
    dsAnh.value = data.anh || [];
    dsThuMuc.value = data.thu_muc?.danh_sach || [];
    soChuaXep.value = data.thu_muc?.chua_xep || 0;
    soYeuThich.value = data.thu_muc?.yeu_thich || 0;
    tatCaId.value = data.tat_ca_id || [];
    conNua.value = !!data.con_nua;
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_NAP'));
  } finally {
    dangTai.value = false;
  }
};
nap();

// Gõ tới đâu gọi tới đó thì mỗi chữ cái là một lượt gọi server. Chờ người ta gõ
// xong hẵng hỏi.
let henTim = null;
watch(thuMucChon, () => nap());
// Nạp lại từ trang 1 chứ không sắp tại chỗ: `dsAnh` mới có 60 tấm đầu.
watch(sapXep, giaTri => {
  try {
    window.localStorage.setItem(KHOA_SAP_XEP, giaTri);
  } catch {
    // Không lưu được thì chỉ mất việc nhớ lựa chọn.
  }
  // Thứ tự đổi thì số badge trên ảnh đã chọn không còn khớp lưới. Ảnh đã vào
  // khay thì vẫn giữ chọn, để lưới và khay khớp nhau.
  daChon.value = [...daVaoKhay.value];
  nap();
});
watch(tuKhoa, () => {
  clearTimeout(henTim);
  henTim = setTimeout(nap, 300);
});
onBeforeUnmount(() => clearTimeout(henTim));

const napThem = async () => {
  if (!conNua.value || dangTaiThem.value || dangTai.value) return;
  dangTaiThem.value = true;
  try {
    const { data } = await KhoAnhAPI.danhSach({
      ...thamSo(),
      trang: trang.value + 1,
    });
    trang.value += 1;
    dsAnh.value = dsAnh.value.concat(data.anh || []);
    conNua.value = !!data.con_nua;
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_NAP'));
  } finally {
    dangTaiThem.value = false;
  }
};

// Cuộn tới đáy thì xin tiếp. `IntersectionObserver` chứ không nghe sự kiện
// scroll: trình duyệt tự báo, không phải tính toán mỗi khung hình.
let theoDoi = null;
const datMoc = el => {
  theoDoi?.disconnect();
  if (!el) return;
  theoDoi = new IntersectionObserver(
    muc => {
      if (muc[0]?.isIntersecting) napThem();
    },
    { rootMargin: '400px' }
  );
  theoDoi.observe(el);
};
onBeforeUnmount(() => theoDoi?.disconnect());

const dong = () => {
  hien.value = false;
  // Có ảnh vào khay (tải lên hoặc chèn) thì đóng bảng là con trỏ về khung soạn,
  // gõ hoặc Enter được ngay.
  if (daVaoKhay.value.length) props.sauKhiChen?.();
};

const boKhoiKhay = ids => {
  const go = ids.filter(id => daVaoKhay.value.includes(id));
  go.forEach(id => props.boKhoiKhay?.(id));
  daVaoKhay.value = daVaoKhay.value.filter(id => !go.includes(id));
};

const datCho = anh => {
  const i = daChon.value.indexOf(anh.id);
  if (i === -1) {
    daChon.value.push(anh.id);
    return;
  }
  daChon.value.splice(i, 1);
  boKhoiKhay([anh.id]);
};

const thuTu = id => daChon.value.indexOf(id) + 1;

// Chọn tất cả TRONG bộ lọc đang mở, kể cả những tấm chưa cuộn tới — server gửi
// sẵn danh sách id ở trang đầu. Chọn cả kho 344 tấm rồi chèn vào khung soạn tin
// thì không ai muốn, nên giới hạn theo thư mục và ô tìm là cố ý.
const chonTatCa = () => {
  if (daChon.value.length === tatCaId.value.length) {
    boKhoiKhay(daChon.value);
    daChon.value = [];
    return;
  }
  // Giữ thứ tự đang có (ảnh vừa tải lên đứng đầu, khớp khay), nối phần còn lại.
  daChon.value = [
    ...daChon.value,
    ...tatCaId.value.filter(id => !daChon.value.includes(id)),
  ];
};

// Tai byte anh ve roi day vao khung soan tin nhu tep binh thuong.
// KHONG gui ngay: nguoi dung phai thay anh truoc, go loi nhan, roi tu bam gui.
const chen = async () => {
  if (!daChon.value.length || dangChen.value) return;
  const chon = daChon.value
    .map(id => dsAnh.value.find(a => a.id === id))
    .filter(Boolean);
  if (props.traVeId) {
    // ponytail: chi tra nhung tam da tai ve luoi (co URL de hien thu nho). "Chon
    // tat ca" qua 60 tam chua cuon toi se roi phan chua tai — mau tra loi khong
    // ai gan ca tram anh; can thi xin server tra anh theo id.
    emit('chon', chon);
    daChon.value = [];
    dong();
    return;
  }
  // Ảnh đã tự vào khay lúc tải lên thì không chèn lại — tránh nhân đôi.
  const moi = chon.filter(a => !daVaoKhay.value.includes(a.id));
  dangChen.value = true;
  try {
    await chenAnhVaoKhay(moi, props.onFileUpload);
    daVaoKhay.value.push(...moi.map(a => a.id));
    daChon.value = [];
    dong();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_CHON'));
  } finally {
    dangChen.value = false;
  }
};

// Chèn MỘT tấm, bỏ qua bước chọn — phần lớn lượt dùng là gửi một ảnh.
// Vẫn KHÔNG gửi: ảnh vào khay chờ, người trực tự bấm gửi.
const chenMot = async anh => {
  if (dangChen.value || props.traVeId) return;
  dangChen.value = true;
  try {
    if (!daVaoKhay.value.includes(anh.id)) {
      await chenAnhVaoKhay([anh], props.onFileUpload);
      daVaoKhay.value.push(anh.id);
    }
    daChon.value = [];
    dong();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_CHON'));
  } finally {
    dangChen.value = false;
  }
};

// Đang mở "Tất cả", "Yêu thích" hay "Chưa xếp" thì ảnh mới về "chưa xếp"; đang
// mở một thư mục thật thì rơi thẳng vào đó.
const idThuMucDangMo = () =>
  /^\d+$/.test(String(thuMucChon.value)) ? thuMucChon.value : null;

// Tải lên NHIỀU tệp một lượt. Trước đây mỗi lần chỉ một tệp, thêm bộ ảnh 30 tấm
// là bấm 30 lần — đó là lý do gần như không ai tự đổ ảnh vào kho.
const taiLen = async dsTep => {
  const anh = [...dsTep].filter(f => f.type.startsWith('image/'));
  if (!anh.length) return;
  dangTai.value = true;
  let loi = 0;
  try {
    // Tuan tu chu khong song song: 30 tep cung luc lam nghen ca cai nay lan
    // duong gui tin cua nguoi khac, va loi thi khong biet tam nao hong.
    /* eslint-disable no-restricted-syntax, no-await-in-loop */
    for (const tep of anh) {
      try {
        const { data } = await KhoAnhAPI.taiLen({
          tep,
          thuMucId: idThuMucDangMo(),
        });
        // Chọn sẵn theo thứ tự tải lên, để chỉ cần bấm "Chèn".
        if (!daChon.value.includes(data.id)) daChon.value.push(data.id);
        // Mở từ khung soạn: đưa vào khay NGAY, bảng vẫn mở. Người trực quen tải
        // lên xong là thoát — thoát ra thì ảnh đã nằm sẵn. Dùng luôn tệp gốc trên
        // máy, khỏi tải ngược từ server về.
        if (props.onFileUpload && !props.traVeId) {
          props.onFileUpload({
            name: tep.name,
            type: tep.type,
            size: tep.size,
            file: tep,
            bonbozAnhId: data.id,
          });
          daVaoKhay.value.push(data.id);
        }
      } catch {
        loi += 1;
      }
    }
    /* eslint-enable no-restricted-syntax, no-await-in-loop */
  } finally {
    dangTai.value = false;
  }
  if (loi) useAlert(t('BONBOZ.KHO_ANH.LOI_TAI_LEN_SO', { so: loi }));
  await nap();
};

const chonTep = async suKien => {
  await taiLen(suKien.target.files || []);
  suKien.target.value = '';
};

const tha = async suKien => {
  dangKeo.value = false;
  if (!isAdmin.value) return;
  await taiLen(suKien.dataTransfer?.files || []);
};

const ghim = async anh => {
  try {
    const { data } = await KhoAnhAPI.sua({
      id: anh.id,
      yeuThich: !anh.yeu_thich,
    });
    anh.yeu_thich = data.yeu_thich;
    soYeuThich.value += data.yeu_thich ? 1 : -1;
    if (thuMucChon.value === 'yeu_thich' && !data.yeu_thich) nap();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_GHIM'));
  }
};

const hoiSuaTen = anh => {
  anhSuaTen.value = anh;
  tenMoi.value = anh.ten;
  hopSuaTen.value?.open();
};

const suaTen = async () => {
  const anh = anhSuaTen.value;
  if (!anh || !tenMoi.value.trim()) return;
  try {
    const { data } = await KhoAnhAPI.sua({
      id: anh.id,
      ten: tenMoi.value.trim(),
    });
    anh.ten = data.ten;
    // Hộp có ô nhập: chỉ đóng khi lưu được; lỗi thì giữ mở để sửa, khỏi gõ lại.
    hopSuaTen.value?.close();
  } catch (e) {
    useAlert(e?.response?.data?.error || t('BONBOZ.KHO_ANH.LOI_SUA_TEN'));
  }
};

const hoiXoa = anh => {
  anhSapXoa.value = anh;
  hopXoa.value?.open();
};

const hoiXoaNhieu = () => {
  anhSapXoa.value = null;
  hopXoa.value?.open();
};

// Dialog của upstream chỉ phát `confirm`, KHÔNG tự đóng — bên gọi phải gọi close().
// Hộp xác nhận đơn thuần đóng ngay khi bấm: vừa chặn bấm hai lần, vừa tránh
// chữ trong hộp vẽ lại giữa chừng (từng hiện "Xoá 0 ảnh" sau khi xoá xong).
const xoa = async () => {
  const anh = anhSapXoa.value;
  hopXoa.value?.close();
  if (!anh && !daChon.value.length) return;
  try {
    if (anh) {
      await KhoAnhAPI.xoa({ id: anh.id });
      daChon.value = daChon.value.filter(id => id !== anh.id);
    } else {
      await KhoAnhAPI.xoaNhieu({ ids: daChon.value });
      daChon.value = [];
    }
    await nap();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_XOA'));
  } finally {
    anhSapXoa.value = null;
  }
};

const hoiChuyen = () => {
  // Đang mở một thư mục thì phần lớn lần bấm là muốn GỠ khỏi chính nó; ngược
  // lại là muốn thêm vào đâu đó.
  const dangMo = idThuMucDangMo();
  thuMucDich.value = dangMo || dsThuMuc.value[0]?.id || '';
  kieuChuyen.value = dangMo ? 'bo' : 'them';
  hopChuyen.value?.open();
};

const chuyen = async () => {
  if (dangLam.value) return;
  hopChuyen.value?.close();
  dangLam.value = true;
  try {
    const { data } = await KhoAnhAPI.chuyen({
      ids: daChon.value,
      thuMucId: thuMucDich.value,
      kieu: kieuChuyen.value,
    });
    useAlert(t('BONBOZ.KHO_ANH.CHUYEN_XONG', { so: data.da_chuyen }));
    daChon.value = [];
    await nap();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_CHUYEN'));
  } finally {
    dangLam.value = false;
  }
};

const hoiThuMuc = (tm = null) => {
  thuMucSua.value = tm;
  tenThuMuc.value = tm?.ten || '';
  hopThuMuc.value?.open();
};

const luuThuMuc = async () => {
  const ten = tenThuMuc.value.trim();
  if (!ten) return;
  try {
    if (thuMucSua.value) {
      await KhoAnhAPI.suaThuMuc({
        id: thuMucSua.value.id,
        ten,
      });
    } else {
      await KhoAnhAPI.taoThuMuc({ ten });
    }
    // Trùng tên thư mục thì server từ chối — giữ hộp mở để đổi tên khác.
    hopThuMuc.value?.close();
    await nap();
  } catch (e) {
    useAlert(e?.response?.data?.error || t('BONBOZ.KHO_ANH.LOI_THU_MUC'));
  }
};

const hoiXoaThuMuc = tm => {
  thuMucSapXoa.value = tm;
  hopXoaThuMuc.value?.open();
};

const xoaThuMuc = async () => {
  const tm = thuMucSapXoa.value;
  hopXoaThuMuc.value?.close();
  if (!tm) return;
  try {
    const { data } = await KhoAnhAPI.xoaThuMuc({
      id: tm.id,
    });
    if (String(thuMucChon.value) === String(tm.id)) thuMucChon.value = '';
    useAlert(
      t('BONBOZ.KHO_ANH.XOA_THU_MUC_XONG', { so: data.anh_ve_chua_xep })
    );
    await nap();
  } catch {
    useAlert(t('BONBOZ.KHO_ANH.LOI_THU_MUC'));
  } finally {
    thuMucSapXoa.value = null;
  }
};
</script>

<template>
  <Modal v-model:show="hien" :on-close="dong" size="medium">
    <div
      class="flex flex-col h-[34rem] max-h-[80vh] w-full"
      @dragover.prevent="dangKeo = isAdmin"
      @dragleave="dangKeo = false"
      @drop.prevent="tha"
    >
      <div class="flex items-center justify-between gap-3 px-6 pt-6 pb-3">
        <h3 class="text-base font-medium text-n-slate-12">
          {{ $t('BONBOZ.KHO_ANH.TIEU_DE') }}
        </h3>
        <div class="flex items-center gap-2 ltr:mr-8 rtl:ml-8">
          <select
            v-model="sapXep"
            class="!mb-0 !h-8 !w-auto text-sm"
            :title="$t('BONBOZ.KHO_ANH.SAP_XEP')"
          >
            <option value="moi_nhat">
              {{ $t('BONBOZ.KHO_ANH.SAP_MOI_NHAT') }}
            </option>
            <option value="cu_nhat">
              {{ $t('BONBOZ.KHO_ANH.SAP_CU_NHAT') }}
            </option>
            <option value="ten_az">
              {{ $t('BONBOZ.KHO_ANH.SAP_TEN_AZ') }}
            </option>
            <option value="ten_za">
              {{ $t('BONBOZ.KHO_ANH.SAP_TEN_ZA') }}
            </option>
          </select>
          <input
            v-model="tuKhoa"
            type="text"
            class="!mb-0 !h-8 max-w-56 text-sm"
            :placeholder="$t('BONBOZ.KHO_ANH.TIM')"
          />
        </div>
      </div>

      <div
        class="flex flex-col flex-1 min-h-0 border-t md:flex-row border-n-weak"
      >
        <!-- BonBoZ: duoi 768px xep DOC — cot thu muc thanh dai chip ngang o tren.
             Giu hai cot thi tren man 390px cot thu muc 176px an gan nua be
             ngang modal, phan anh con ~130px cho bon cot thumbnail. -->
        <div
          class="flex w-full gap-1 px-2 py-2 overflow-x-auto border-b shrink-0 border-n-weak md:flex-col md:overflow-x-visible md:overflow-y-auto md:w-44 md:border-b-0 md:border-e"
        >
          <!-- O tim thu muc chi hien khi co kha nhieu thu muc: chin cai thi mat
               nhanh hon go. -->
          <input
            v-if="dsThuMuc.length > 8"
            v-model="timThuMuc"
            type="text"
            class="!mb-1 !h-7 hidden md:block text-xs"
            :placeholder="$t('BONBOZ.KHO_ANH.TIM_THU_MUC')"
          />
          <button
            class="px-3 py-1.5 text-sm rounded-md whitespace-nowrap shrink-0 md:w-full md:px-2 md:text-start md:truncate md:whitespace-normal"
            :class="
              thuMucChon === ''
                ? 'bg-n-brand/10 text-n-brand font-medium'
                : 'text-n-slate-11 hover:bg-n-alpha-1'
            "
            @click="thuMucChon = ''"
          >
            {{ $t('BONBOZ.KHO_ANH.TAT_CA') }}
          </button>
          <button
            v-if="soYeuThich"
            class="px-3 py-1.5 text-sm rounded-md whitespace-nowrap shrink-0 md:w-full md:px-2 md:text-start md:truncate md:whitespace-normal"
            :class="
              thuMucChon === 'yeu_thich'
                ? 'bg-n-brand/10 text-n-brand font-medium'
                : 'text-n-slate-11 hover:bg-n-alpha-1'
            "
            @click="thuMucChon = 'yeu_thich'"
          >
            {{ $t('BONBOZ.KHO_ANH.YEU_THICH') }}
            <span class="text-xs tabular-nums opacity-60">{{
              soYeuThich
            }}</span>
          </button>
          <div
            v-for="tm in thuMucHienThi"
            :key="tm.id"
            class="flex items-center group/tm shrink-0 md:w-full"
          >
            <button
              class="flex-1 min-w-0 px-3 py-1.5 text-sm rounded-md whitespace-nowrap md:px-2 md:text-start md:truncate md:whitespace-normal"
              :class="
                String(thuMucChon) === String(tm.id)
                  ? 'bg-n-brand/10 text-n-brand font-medium'
                  : 'text-n-slate-11 hover:bg-n-alpha-1'
              "
              @click="thuMucChon = tm.id"
            >
              {{ tm.ten }}
              <span class="text-xs tabular-nums opacity-60">{{ tm.so }}</span>
            </button>
            <button
              v-if="isAdmin"
              class="hidden shrink-0 md:group-hover/tm:block p-0.5 text-n-slate-11"
              :title="$t('BONBOZ.KHO_ANH.DOI_TEN_THU_MUC')"
              @click.stop="hoiThuMuc(tm)"
            >
              <span class="i-lucide-pencil size-3" />
            </button>
            <button
              v-if="isAdmin"
              class="hidden shrink-0 md:group-hover/tm:block p-0.5 text-n-ruby-11"
              :title="$t('BONBOZ.KHO_ANH.XOA_THU_MUC')"
              @click.stop="hoiXoaThuMuc(tm)"
            >
              <span class="i-lucide-trash-2 size-3" />
            </button>
          </div>
          <button
            v-if="soChuaXep"
            class="px-3 py-1.5 text-sm rounded-md whitespace-nowrap shrink-0 md:w-full md:px-2 md:text-start md:truncate md:whitespace-normal"
            :class="
              thuMucChon === 'chua_xep'
                ? 'bg-n-brand/10 text-n-brand font-medium'
                : 'text-n-slate-11 hover:bg-n-alpha-1'
            "
            @click="thuMucChon = 'chua_xep'"
          >
            {{ $t('BONBOZ.KHO_ANH.CHUA_XEP') }}
            <span class="text-xs tabular-nums opacity-60">{{ soChuaXep }}</span>
          </button>
          <button
            v-if="isAdmin"
            class="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md whitespace-nowrap shrink-0 text-n-slate-11 hover:bg-n-alpha-1 md:w-full md:px-2 md:text-start"
            @click="hoiThuMuc(null)"
          >
            <span class="i-lucide-folder-plus size-3.5" />
            {{ $t('BONBOZ.KHO_ANH.THEM_THU_MUC') }}
          </button>
        </div>

        <div
          class="flex-1 min-w-0 p-3 overflow-y-auto"
          :class="dangKeo ? 'ring-2 ring-inset ring-n-brand' : ''"
        >
          <div
            v-if="dangTai"
            class="grid h-full text-sm place-items-center text-n-slate-11"
          >
            {{ $t('BONBOZ.KHO_ANH.DANG_TAI') }}
          </div>
          <div
            v-else-if="!dsAnh.length"
            class="grid h-full text-sm place-items-center text-n-slate-11"
          >
            {{ $t('BONBOZ.KHO_ANH.TRONG') }}
          </div>
          <div
            v-else
            class="grid grid-cols-3 gap-3 sm:grid-cols-4 xl:grid-cols-5"
          >
            <div
              v-for="anh in dsAnh"
              :key="anh.id"
              class="relative group"
              role="button"
              @click="datCho(anh)"
            >
              <div
                class="relative overflow-hidden border-2 rounded-lg aspect-square bg-n-alpha-1 hover:border-n-brand"
                :class="thuTu(anh.id) ? 'border-n-brand' : 'border-transparent'"
              >
                <!-- `lazy`: trang Bonboz Clinic co 344 tam ma the img tro
                     THANG vao anh goc — cuon het la tai ~90 MB neu tai het. -->
                <!-- Video (#119): `preload=metadata` chi tai khung dau, khong
                     tai ca tep khi cuon qua luoi. -->
                <video
                  v-if="anh.loai === 'video'"
                  :src="anh.url"
                  preload="metadata"
                  muted
                  playsinline
                  class="object-cover w-full h-full"
                />
                <img
                  v-else
                  :src="anh.url"
                  :alt="anh.ten"
                  loading="lazy"
                  decoding="async"
                  class="object-cover w-full h-full"
                />
                <span
                  v-if="anh.loai === 'video'"
                  class="absolute inset-0 grid pointer-events-none place-items-center"
                >
                  <span
                    class="grid text-white rounded-full size-6 place-items-center bg-[rgb(0_0_0/0.55)]"
                  >
                    <span class="i-lucide-play size-3.5" />
                  </span>
                </span>
                <!-- Thanh thao tac: can giua o day anh, cach deu. Truoc day neo goc
                     phai tren, them nut chen nhanh thi hang dai ra va de len so thu
                     tu o goc trai. Dien thoai hien san; may tinh hien khi re chuot. -->
                <div
                  class="absolute inset-x-0 bottom-0 flex justify-center gap-1.5 p-1.5 md:opacity-0 md:pointer-events-none md:group-hover:opacity-100 md:group-hover:pointer-events-auto"
                >
                  <!-- Khong co isAdmin: moi nguoi truc deu phai gui duoc anh.
                       An o che do traVeId — o do khong co khung soan tin. -->
                  <button
                    v-if="!traVeId"
                    class="grid rounded place-items-center size-6 bg-n-solid-1/90 text-n-brand"
                    :disabled="dangChen"
                    :title="$t('BONBOZ.KHO_ANH.CHEN_NHANH')"
                    @click.stop="chenMot(anh)"
                  >
                    <span class="i-lucide-corner-down-left size-3.5" />
                  </button>
                  <!-- Ghim: chi may tinh — dien thoai 3 cot, bon nut khong vua. -->
                  <button
                    v-if="isAdmin && !anh.yeu_thich"
                    class="hidden rounded md:grid place-items-center size-6 bg-n-solid-1/90 text-n-slate-11"
                    :title="$t('BONBOZ.KHO_ANH.GHIM')"
                    @click.stop="ghim(anh)"
                  >
                    <span class="i-lucide-star size-3.5" />
                  </button>
                  <button
                    v-if="isAdmin"
                    class="grid rounded place-items-center size-6 bg-n-solid-1/90 text-n-slate-11"
                    :title="$t('BONBOZ.KHO_ANH.SUA_TEN')"
                    @click.stop="hoiSuaTen(anh)"
                  >
                    <span class="i-lucide-pencil size-3.5" />
                  </button>
                  <button
                    v-if="isAdmin"
                    class="grid rounded place-items-center size-6 bg-n-solid-1/90 text-n-ruby-11"
                    :title="$t('BONBOZ.KHO_ANH.XOA')"
                    @click.stop="hoiXoa(anh)"
                  >
                    <span class="i-lucide-trash-2 size-3.5" />
                  </button>
                </div>
              </div>
              <!-- So thu tu chu khong phai dau tick: cum anh gui di theo dung
                   thu tu nay, nguoi truc phai thay truoc khi bam Chen. -->
              <span
                v-if="thuTu(anh.id)"
                class="absolute grid text-xs font-medium text-white rounded-full top-1.5 left-1.5 place-items-center size-5 bg-n-brand"
              >
                {{ thuTu(anh.id) }}
              </span>
              <!-- Dau ghim o goc phai tren, luon hien de biet anh nao da ghim.
                   Quan tri bam vao de bo ghim. -->
              <button
                v-if="anh.yeu_thich"
                class="absolute grid rounded place-items-center size-6 top-1.5 right-1.5 bg-n-solid-1/90 text-n-amber-11"
                :disabled="!isAdmin"
                :title="$t('BONBOZ.KHO_ANH.BO_GHIM')"
                @click.stop="isAdmin && ghim(anh)"
              >
                <span class="i-lucide-star size-3.5" />
              </button>
              <p class="mt-1 text-xs truncate text-n-slate-11">{{ anh.ten }}</p>
            </div>
          </div>
          <!-- Moc cuoi luoi: cuon toi day thi xin trang tiep. -->
          <div
            v-if="conNua"
            :ref="datMoc"
            class="py-4 text-xs text-center text-n-slate-11"
          >
            {{ $t('BONBOZ.KHO_ANH.DANG_TAI') }}
          </div>
        </div>
      </div>

      <!-- Thanh dưới: lời nhắn và nút gửi vẫn dùng của khung soạn tin. -->
      <div
        class="flex flex-wrap items-center gap-2 px-6 py-3 border-t border-n-weak bg-n-solid-2"
      >
        <label v-if="isAdmin" class="shrink-0">
          <input
            type="file"
            accept="image/*,video/mp4"
            multiple
            class="hidden"
            @change="chonTep"
          />
          <span
            class="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md cursor-pointer bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3"
          >
            <span class="i-lucide-plus size-3.5" />
            {{ $t('BONBOZ.KHO_ANH.THEM_ANH') }}
          </span>
        </label>
        <NextButton
          v-if="tatCaId.length"
          sm
          faded
          slate
          :label="
            daChon.length === tatCaId.length
              ? $t('BONBOZ.KHO_ANH.BO_CHON_TAT_CA')
              : $t('BONBOZ.KHO_ANH.CHON_TAT_CA', { so: tatCaId.length })
          "
          @click="chonTatCa"
        />
        <template v-if="daChon.length">
          <!-- Chip dem: bam dau x la bo chon het, khoi bam lai tung tam. -->
          <button
            class="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-md bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3"
            @click="daChon = []"
          >
            {{ $t('BONBOZ.KHO_ANH.DA_CHON', { so: daChon.length }) }}
            <span class="i-lucide-x size-3" />
          </button>
          <NextButton
            v-if="isAdmin"
            sm
            faded
            slate
            :label="$t('BONBOZ.KHO_ANH.CHUYEN_THU_MUC')"
            @click="hoiChuyen"
          />
          <NextButton
            v-if="isAdmin"
            sm
            faded
            ruby
            :label="$t('BONBOZ.KHO_ANH.XOA_DA_CHON')"
            @click="hoiXoaNhieu"
          />
        </template>
        <NextButton
          class="ltr:ml-auto rtl:mr-auto"
          sm
          :disabled="!daChon.length || dangChen"
          :is-loading="dangChen"
          :label="$t('BONBOZ.KHO_ANH.CHEN')"
          @click="chen"
        />
      </div>
    </div>

    <!-- Hop xac nhan that, khong dung window.confirm: hop cua trinh duyet hien
         ten mien "inboxdev.bonboz.vn says" va khong theo giao dien nao ca. -->
    <Dialog
      ref="hopXoa"
      type="alert"
      :title="$t('BONBOZ.KHO_ANH.XOA')"
      :description="
        anhSapXoa
          ? $t('BONBOZ.KHO_ANH.HOI_XOA', { ten: anhSapXoa.ten })
          : $t('BONBOZ.KHO_ANH.HOI_XOA_NHIEU', { so: daChon.length })
      "
      :confirm-button-label="$t('BONBOZ.KHO_ANH.XAC_NHAN_XOA')"
      @confirm="xoa"
    />

    <Dialog
      ref="hopSuaTen"
      :title="$t('BONBOZ.KHO_ANH.SUA_TEN')"
      :confirm-button-label="$t('BONBOZ.KHO_ANH.LUU')"
      @confirm="suaTen"
    >
      <input id="kho-anh-ten-moi" v-model="tenMoi" type="text" class="mt-1" />
    </Dialog>

    <Dialog
      ref="hopThuMuc"
      :title="
        thuMucSua
          ? $t('BONBOZ.KHO_ANH.DOI_TEN_THU_MUC')
          : $t('BONBOZ.KHO_ANH.THEM_THU_MUC')
      "
      :confirm-button-label="$t('BONBOZ.KHO_ANH.LUU')"
      @confirm="luuThuMuc"
    >
      <input
        id="kho-anh-ten-thu-muc"
        v-model="tenThuMuc"
        type="text"
        class="mt-1"
        :placeholder="$t('BONBOZ.KHO_ANH.TEN_THU_MUC')"
      />
    </Dialog>

    <!-- Xoa thu muc KHONG xoa anh — noi ro so anh se roi ve "chua xep". -->
    <Dialog
      ref="hopXoaThuMuc"
      type="alert"
      :title="$t('BONBOZ.KHO_ANH.XOA_THU_MUC')"
      :description="
        $t('BONBOZ.KHO_ANH.HOI_XOA_THU_MUC', {
          ten: thuMucSapXoa?.ten,
          so: thuMucSapXoa?.so,
        })
      "
      :confirm-button-label="$t('BONBOZ.KHO_ANH.XAC_NHAN_XOA')"
      @confirm="xoaThuMuc"
    />

    <Dialog
      ref="hopChuyen"
      :title="$t('BONBOZ.KHO_ANH.CHUYEN_THU_MUC')"
      :description="$t('BONBOZ.KHO_ANH.CHUYEN_MO_TA', { so: daChon.length })"
      :confirm-button-label="$t('BONBOZ.KHO_ANH.CHUYEN')"
      :is-loading="dangLam"
      @confirm="chuyen"
    >
      <div class="flex flex-col gap-3">
        <select id="kho-anh-kieu-chuyen" v-model="kieuChuyen" class="mt-1">
          <option value="them">{{ $t('BONBOZ.KHO_ANH.XEP_THEM') }}</option>
          <option value="bo">{{ $t('BONBOZ.KHO_ANH.XEP_BO') }}</option>
          <option value="thay">{{ $t('BONBOZ.KHO_ANH.XEP_THAY') }}</option>
        </select>
        <select id="kho-anh-thu-muc-dich" v-model="thuMucDich" class="mt-1">
          <option v-if="kieuChuyen === 'thay'" value="">
            {{ $t('BONBOZ.KHO_ANH.CHUA_XEP') }}
          </option>
          <option v-for="tm in dsThuMuc" :key="tm.id" :value="tm.id">
            {{ tm.ten }}
          </option>
        </select>
      </div>
    </Dialog>
  </Modal>
</template>
